import dynamic from 'next/dynamic';
import { useEffect, useRef, useState } from 'react';
import { cn } from '../../../utils';

const MdKeyboardArrowLeft = dynamic(() =>
  import('react-icons/md').then((mod) => mod.MdKeyboardArrowLeft)
);
const MdKeyboardArrowRight = dynamic(() =>
  import('react-icons/md').then((mod) => mod.MdKeyboardArrowRight)
);

export default function ScrollableWithArrows({
  children,
  className,
  scrollOffset = 100,
  hasDropdown = false,
}) {
  const scrollContainerRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  const checkArrows = () => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      setShowLeftArrow(container.scrollLeft > 0);
      setShowRightArrow(
        Math.ceil(container.scrollLeft) <
          Math.ceil(container.scrollWidth - container.clientWidth)
      );
    }
  };

  useEffect(() => {
    // Check arrows when content changes
    checkArrows();

    // Add resize listener to check arrows when window size changes
    window.addEventListener('resize', checkArrows);

    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      container.addEventListener('scroll', checkArrows);

      return () => {
        container.removeEventListener('scroll', checkArrows);
        window.removeEventListener('resize', checkArrows);
      };
    }
  }, [children]); // Add children to dependency array

  const scroll = (offset) => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollLeft += offset;
    }
  };

  return (
    <>
      {showLeftArrow && (
        <button
          className='hidden font-bold text-black md:block'
          onClick={() => scroll(-scrollOffset)}
        >
          <MdKeyboardArrowLeft className='m-auto text-[20px] font-bold text-black' />
        </button>
      )}
      <div
        ref={scrollContainerRef}
        className={cn(
          'no-scrollbar flex items-center gap-[43px]  scroll-smooth whitespace-nowrap',
          !hasDropdown && 'overflow-x-auto',
          className
        )}
      >
        {children}
      </div>
      {showRightArrow && (
        <button
          className='hidden font-bold  text-black md:block'
          onClick={() => scroll(scrollOffset)}
        >
          <MdKeyboardArrowRight className='m-auto text-[17.45px] text-primary' />
        </button>
      )}
    </>
  );
}
